module.exports = __webpack_public_path__ + "static/media/comments.df255929.svg";